import { FC } from "react";
import { CancelButtonStyled } from "./CancelButton.style";
import { CancelButtonType } from "./CancelButton.types";
import { useTranslation } from "react-i18next";

const CancelButton: FC<CancelButtonType> = (props) => {
  const { disabled, onClick, type, value, className } = props;
  const { t } = useTranslation();
  return (
    <CancelButtonStyled
      className={className}
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {value || t("components.button.cancel")}
    </CancelButtonStyled>
  );
};

export default CancelButton;
